<template>
  <div class="register-form">
    <h2>Verificar contraseña</h2>
    <hr/>
    <form @submit.prevent="confirmReset()">
      <div class="form-item">
        <label>Contraseña</label>
         <input
          autocomplete="new-password"
          :type="showPassword ? 'text' : 'password'"
          v-model="credentials.password" 
          v-validate="'required'" 
          name="password" 
          :class="{'is-invalid': errors.has('password') && !validatePassword(credentials.password)}" 
          placeholder="Password" 
          ref="password">
        <div class="icon_eyes pointer" @click="showPassword = !showPassword">
          <img v-if="showPassword" src="@/assets/img/eye.svg" alt="eye">
          <img v-if="!showPassword" src="@/assets/img/eye-slash.svg" alt="eye">
        </div>
        <button type="button" class="btn btn-block btn-secondary icon-refresh pointer" @click="generate()" title="generar contraseña"><img width="24px" src="@/assets/img/sync.svg" alt="sync"></button>
        <div v-if="submitted && errors.has('password')" class="animated fadeIn invalid-feedback"><font-awesome-icon class="icon" icon="info-circle" /> {{ errors.first('password') }}</div>
      </div>
      <div class="form-item">
        <label>Repetir contraseña</label>
        <input
          autocomplete="new-password"
          :type="showPassword ? 'text' : 'password'"
          v-model="credentials.repeatPass" 
          v-validate="'required|confirmed:password'" 
          name="password_confirmation"
          :class="{'is-invalid': errors.has('password_confirmation') && !validatePassword(credentials.repeatPass)}" 
          placeholder="Password, Again" 
          data-vv-as="password">
        <div v-if="submitted && errors.has('password_confirmation')" class="animated fadeIn invalid-feedback"><font-awesome-icon class="icon" icon="credentials-circle" /> {{ errors.first('password_confirmation') }}</div>
      </div>
      <button type="submit">Confirmar</button>
    </form>
  </div>
</template>

<script>
import Api from '@/Api';

// Plugins
import notification from '@/utils/plugins/NotificationService'

export default {
  name: 'confirm-sidebar',
  data() {
    return {
      token: '',
      credentials: {
        password: '',
        repeatPass: ''
      },
      showPassword: true,
      submitted: false,
      pathname: window.location.hash,
      sizePassword: 8
    }
  },
  created() {
    document.querySelector('#auth_sidebar').style.display = 'block';
  },
  mounted() {
    this.generate();
    const checkUrl = this.pathname.split("?");
    this.token = checkUrl[1];
  },
  methods: {
    confirmReset() {
      this.submitted = true;
      setTimeout(() => {
        this.$validator.validate()
        .then(() => {
          if (!this.validatePassword(this.credentials.password) || !this.checkPassword()) {
            notification.addNotification('La contraseña debe de contener mayúsculas, minúsculas, números y letras', 'warning', 6000);
            return;
          }
          const url = '?' + this.token + '&pass=' + this.credentials.password + '&repeatPass=' + this.credentials.repeatPass;

          return Api().put('confirmReset' + url).then(() => {
            notification.addNotification('Cambio de contraseña realizado con exito', 'success', 10000);
            this.$validator.reset();
          }).catch(() => {
            notification.addNotification('Error cambiando contraseña', 'error', 10000);
            this.$validator.reset();
          });
        })
      }, 100)
    },
    checkPassword() {
      if (this.credentials.password === this.credentials.repeatPass) {
        return true;
      }
      return false;
    },
    generateCharacter(typeCharacter) {
      var listCharacters =	'$+=?@_23456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz';
      var characterGenerate	=	'';
      var valueInf =	0;
      var ValueSup =	0;
  
      switch (typeCharacter){
        case 'minúscula':
          valueInf	=	38;
          ValueSup	=	61;
          break;
        case 'mayúscula':
          valueInf	=	14;
          ValueSup	=	37;
          break;
        case 'número':
          valueInf	=	6;
          ValueSup	=	13;
          break;
        case 'símbolo':	
          valueInf	=	0;
          ValueSup	=	5;
          break;
        case 'aleatorio':
          valueInf	=	0;
          ValueSup	=	61;
  
      } // fin del switch
  
      characterGenerate	=	listCharacters.charAt(this.randomGenerate(valueInf, ValueSup));
      return characterGenerate;
    },
    randomGenerate(numInf, numSup) {
      var i_aleatorio = Math.floor((Math.random() * (numSup - numInf + 1)) + numInf);
      return  i_aleatorio;
    },
    saveCharacter(character, size, arr){
      var saveEmpty	=	false;
      var position			=	0;
  
      while(saveEmpty	!=	true){
        position	=	this.randomGenerate(0, size-1);	// generamos un aleatorio en el rango del tamaño del password
  
        // el array ha sido inicializado con null en sus posiciones. Si es una posición vacía, guardamos el caracter
        if(arr[position] == null){
          arr[position]	=	character;
          saveEmpty	=	true;
        }
      }
  
      return arr;
    },
    generatePassword(size){
      var totalMinus = 0;
      var	totalMayus = 0;
      var	totalNumber =	0;
      var	totalSymbol =	0;
  
      var totalCharacters =	0;			// contador de los caracteres que hemos conseguido
      var temporalCharacters = '';
  
      var password = '';
  
      var arrCharacter = new Array();
  
      for(var i = 0; i < size; i++){		// inicializamos el array con el valor null
        arrCharacter[i]	=	null;
      }
  
      // generamos los distintos tipos de caracteres y los metemos en un password_temporal
      while (totalMinus < 1){
        temporalCharacters	=	this.generateCharacter('minúscula');
        arrCharacter = this.saveCharacter(temporalCharacters, size, arrCharacter);
        totalMinus++;
        totalCharacters++;
      }
  
      while (totalMayus < 1){
        temporalCharacters	=	this.generateCharacter('mayúscula');
        arrCharacter = this.saveCharacter(temporalCharacters, size, arrCharacter);
        totalMayus++;
        totalCharacters++;
      }
  
      while (totalNumber < 1){
        temporalCharacters	=	this.generateCharacter('número');
        arrCharacter = this.saveCharacter(temporalCharacters, size, arrCharacter);
        totalNumber++;
        totalCharacters++;
      }
  
      while (totalSymbol < 1){
        temporalCharacters	=	this.generateCharacter('símbolo');
        arrCharacter = this.saveCharacter(temporalCharacters, size, arrCharacter);
        totalSymbol++;
        totalCharacters++;
      }
  
      // si no hemos generado todos los caracteres que necesitamos, de forma aleatoria añadimos los que nos falten
      // hasta llegar al tamaño de password que nos interesa
      while (totalCharacters < size){
        temporalCharacters	=	this.generateCharacter('aleatorio');
        arrCharacter = this.saveCharacter(temporalCharacters, size, arrCharacter);
        totalCharacters++;
      }
  
      // ahora pasamos el contenido del array a la variable password
      for(let i = 0; i < arrCharacter.length; i++){
        password	=	password + arrCharacter[i];
      }
  
      return password;
    },
    generate() {
      this.credentials.password = this.generatePassword(this.sizePassword);
      this.credentials.repeatPass = this.credentials.password;
      setTimeout(() => {
        this.$validator.validate();
      }, 500)
    },
    validatePassword(password)
    {
      if(password && password.length >= 8)
      {		
        var mayuscula = false;
        var minuscula = false;
        var numero = false;
        var caracter_raro = false;
        
        for(var i = 0;i<password.length;i++)
        {
          if(password.charCodeAt(i) >= 65 && password.charCodeAt(i) <= 90)
          {
            mayuscula = true;
          }
          else if(password.charCodeAt(i) >= 97 && password.charCodeAt(i) <= 122)
          {
            minuscula = true;
          }
          else if(password.charCodeAt(i) >= 48 && password.charCodeAt(i) <= 57)
          {
            numero = true;
          }
          else
          {
            caracter_raro = true;
          }
        }
        if(mayuscula == true && minuscula == true && caracter_raro == true && numero == true)
        {
          return true;
        }
      }
      return false;
    }
  }
}

</script>